import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/store/index';
import en from 'vuetify/src/locale/en';
import sr from '@/locales/vuetify/sr-Latn';

Vue.use(VueI18n)

const messages = {
    en: {
		...require('@/locales/en.json'),
		$vuetify: en,
	},
	sr: {
		...require('@/locales/sr.json'),
		$vuetify: sr,
	}
}

export default new VueI18n({
    
    locale: store.getters['locale/locale'] || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages,
})
